import { IFavoriteProfessionalApi } from '~/domain/FavoriteProfessionals/favoriteProfessionalsTypes';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

export interface IGetFavoriteProfessionalsParams {
  officeId: string;
  jobId?: string;
}

async function getFavoriteProfessionals({
  officeId,
  jobId,
}: IGetFavoriteProfessionalsParams): Promise<IFavoriteProfessionalApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IFavoriteProfessionalApi[]>(`/favorite-professionals`, {
    headers: { ...headers, 'x-office': officeId ?? undefined },
    params: {
      jobId: jobId ?? undefined,
    },
  });

  return response.data;
}

export const favoriteProfessionalsApi = {
  getFavoriteProfessionals,
};
